import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'typeName',
    fieldName: '款项类型',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '公司账户'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '费用金额',
    isMoney: true,
    textAlign: 'right'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'date',
    fieldName: '到账/退款日期'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '登记时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentMark',
    fieldName: '备注说明'
  }
]
